import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { preventDefault } from '../../../utils/events'
import Button, { BUTTON_HEIGHT_16 } from '../../Button'

import * as styles from './InputClearButton.module.css'

import CloseIcon from '../../../icons/close.svg'

function InputClearButton({
  className = styles.InputClearButton,
  height = BUTTON_HEIGHT_16,
  tabIndex,
  tooltipKey = 'Input.ClearTooltipKey',
  tooltipPlacement = FLOATING_ELEMENT_PLACEMENT.bottom,
  onClick,
}) {
  const { t } = useTranslation()

  return (
    <Button.Text
      isGrey
      beforeIconProps={{ Icon: CloseIcon }}
      className={className}
      height={height}
      tabIndex={tabIndex}
      tooltip={t(tooltipKey)}
      tooltipPlacement={tooltipPlacement}
      onClick={onClick}
      onMouseDown={preventDefault} // needs to prevent `onBlur` action
    />
  )
}

export default InputClearButton
